import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import SocialMedia from "./pages/SocialMedia";
import PaymentReturn from "./pages/PaymentReturn";
import Legal from "./pages/Legal";
import SmoothScroll from "./components/SmoothScroll";

function App() {
  return (
    <div className="App grain">
      <SmoothScroll />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/social-media" element={<SocialMedia />} />
          <Route path="/pagamento/retorno" element={<PaymentReturn />} />
          <Route path="/termos" element={<Legal page="termos" />} />
          <Route path="/privacidade" element={<Legal page="privacidade" />} />
          <Route path="/cancelamento" element={<Legal page="cancelamento" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
